import { Box, Button, Divider, Grid, Link, makeStyles, Typography } from '@material-ui/core'
import React from 'react'
import CreateIcon from '@material-ui/icons/Create';
function Objective() {
    const classes = useStyles();
    return <Box my={3}>
        <Grid item xs={12}>
            <Typography variant="h5">
                <Box my={3}>From Coaching Request Briefing, Describe the current circumstances/situation that has led to this request for coaching?</Box>
            </Typography>
        </Grid>


        <Grid container direction="row">
            <Grid item xs={12}>
                <Typography variant="h5">
                    <Box mb={2} >To improve my communication skills</Box>
                    <Divider />
                </Typography>
            </Grid>
        </Grid>
        <Grid container direction="row">
            <Box bgcolor="#F2F2F2" my={3} p={2}>
                <Grid item xs={12}>
                    <Typography variant="h5">
                        <Box mb={2} fontWeight="fontWeightBold">Coaching needs</Box>
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h5">
                        <Box mb={2} >Align each objective with the relevant Competency. If more than one Competency is relevant, then select the predominant competency. This should take place during the Contracting Session. Review your ongoing evaluation throughout your coaching arrangement but specifically at the midpoint and Completion Session.</Box>
                    </Typography>
                </Grid>
            </Box>
        </Grid>
        <Box my={3}>
            <Grid container direction="row">
                <Grid item xs={8}>
                    <Typography variant="h5" style={{ color: "#981B1E" }}>
                        <Box mb={2} fontWeight="fontWeightBold" >Objective summary</Box>
                    </Typography>
                </Grid>
                <Grid item xs={4} >
                    <Box textAlign="right">
                        <Button disableElevation variant="contained" color="secondary" className={classes.btnComplete}>+ Add objective</Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
        <Grid container direction="row">
            <Grid item xs={12}>
                <Box border={1} p={1} style={{ borderColor: "#E2E2E3" }}>
                    <Grid container direction="row">
                        <Grid item xs={3}>
                            <Typography variant="h5">
                                <Box fontWeight="fontWeightBold" >Objectives</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="h5">
                                <Box fontWeight="fontWeightBold" >Percentage completion</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="h5">
                                <Box fontWeight="fontWeightBold" >Evidence/Comments</Box>
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
                {
                    [1, 2, 2, 2, 2, 2].map((option) => {
                        return <Box border={1} p={1} style={{ borderColor: "#E2E2E3" }}>
                            <Grid container direction="row">
                                <Grid item xs={3}>
                                    <Typography variant="h5" >
                                        <Box >
                                            <Link style={{ color: "#981B1E" }}>Objectives</Link>
                                        </Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="h5">
                                        <Box >Percentage completion</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="h5">
                                        <Box  >Evidence/Comments</Box>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    })
                }
            </Grid>
        </Grid>
        <Box my={3}>
            <Grid container direction="row">
                <Grid item xs={8}>
                    <Typography variant="h5" style={{ color: "#981B1E" }}>
                        <Box fontWeight="fontWeightBold" >Objective 1</Box>
                    </Typography>
                </Grid>
            </Grid>
        </Box>
        <Grid container direction="row">
            <Grid item xs={12}>
                <Box bgcolor="###981B1E1A" p={2}>
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={11}>
                            <Typography variant="h5" style={{ color: "#981B1E" }}>
                                <Box fontWeight="fontWeightBold">Contracting session</Box>
                            </Typography>
                            <Typography variant="h5">
                                <Box >Completed with input from the coachee’s Line Manager (if applicable)</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <Box textAlign="right"><CreateIcon style={{ color: "#981B1E" }} /></Box>
                        </Grid>
                    </Grid>

                </Box>
            </Grid>
            <Grid item xs={12}>
                <Grid container direction="row" alignItems="center">

                    <Grid item xs={12}>
                        <Box my={3} px={3}>
                            <Grid container direction="row" alignItems="center">
                                <Grid item xs={12}>
                                    <Typography variant="h5" style={{ color: "#981B1E" }}>
                                        <Box mb={1}>Description of objective</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} >
                                    <Typography variant="h5">
                                        <Box>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</Box>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box my={3} px={3}>
                            <Grid container direction="row" alignItems="center">
                                <Grid item xs={8}>
                                    <Box border={1}>
                                        <Grid container direction="row" alignItems="center" spacing={2}>
                                            <Grid item xs={6}>
                                                <Typography variant="h5" style={{ color: "#981B1E" }}>
                                                    <Box p={1}>Leadership Metric</Box>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6} >
                                                <Typography variant="h5" style={{ color: "#981B1E" }}>
                                                    <Box p={1}>Description</Box>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Box p={1} border={1}>

                                        <Grid container direction="row" alignItems="center" spacing={2}>
                                            <Grid item xs={6}>
                                                <Typography variant="h5">
                                                    <Box p={1}>Competency 1</Box>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6} >
                                                <Typography variant="h5">
                                                    <Box p={1}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</Box>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box my={3} px={3}>
                            <Grid container direction="row" alignItems="center">
                                <Grid item xs={12}>
                                    <Typography variant="h5" style={{ color: "#981B1E" }}>
                                        <Box mb={1}>What will you do to get there?</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} >
                                    <Typography variant="h5">
                                        <Box>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</Box>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box my={3} px={3}>
                            <Grid container direction="row" alignItems="center">
                                <Grid item xs={12}>
                                    <Typography variant="h5" style={{ color: "#981B1E" }}>
                                        <Box mb={1}>Business Impact</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} >
                                    <Typography variant="h5">
                                        <Box>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</Box>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box my={3} px={3}>
                            <Grid container direction="row" alignItems="center">
                                <Grid item xs={12}>
                                    <Typography variant="h5" style={{ color: "#981B1E" }}>
                                        <Box mb={1}>Measurement Metrics</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} >
                                    <Typography variant="h5">
                                        <Box>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</Box>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

        </Grid>

        <Grid container direction="row">
            <Grid item xs={12}>
                <Box bgcolor="#981B1E1A" p={2}>
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={11}>
                            <Typography variant="h5" style={{ color: "#981B1E" }}>
                                <Box fontWeight="fontWeightBold">Last session</Box>
                            </Typography>
                            <Typography variant="h5">
                                <Box >Results Summary at end of Coaching Engagement</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <Box textAlign="right"><CreateIcon style={{ color: "#981B1E" }} /></Box>
                        </Grid>
                    </Grid>

                </Box>
            </Grid>
            <Grid item xs={12}>
                <Grid container direction="row" alignItems="center">

                    <Grid item xs={12}>
                        <Box my={3} px={3}>
                            <Grid container direction="row" alignItems="center">
                                <Grid item xs={12}>
                                    <Typography variant="h5">
                                        <Box mb={1}>Percentage completion</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} >
                                    <Typography variant="h5">
                                        <Box>50%</Box>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

        </Grid>


    </Box>
}

export default Objective



const useStyles = makeStyles({
    bgGray: {
        backgroundColor: "#F7F7F7",
        padding: 20,
    },
    btnComplete: {
        backgroundColor: "#981B1E",
        textTransform: "capitalize",
        fontSize: 14,
        marginRight: 20,
    },
    btnSearch: {
        backgroundColor: "#981B1E",
        textTransform: "capitalize",
        fontSize: 14,
    },

    f12: { fontSize: 12 },
});